import React from 'react';
import styled from 'styled-components';
import {
    Colours,
} from '@ratehub/base-ui';
import { LayoutGlobals, ZIndex } from '@ratehub/base-ui/src/styles';
import isStickyMobileAdEnabled from '../functions/isStickyMobileAdEnabled';
import AdLeaderboard from './AdLeaderboard';


function AdStickyMobile() {
    const stickyMobileAdEnabled = isStickyMobileAdEnabled();
    return stickyMobileAdEnabled && (
        <MyContainer>
            <AdLeaderboard overrideAdIndex="mobilesticky" />
        </MyContainer>
    );
}

const MyContainer = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100vw;
    background-color: ${Colours.GRAY_LIGHT};
    z-index: ${ZIndex.HEADER_FOOTER};

    @media screen and (min-width: ${LayoutGlobals.STICKY_MOBILE_AD_SWITCH_WIDTH}) {
        display: none;
    }
`;

export default AdStickyMobile;
